"use client";
import React from "react";
import styles from "./Expectations.module.css";
interface Step {
  title: string;
  copy: (value?: string) => string;
  subtitle: string;
}

const steps: Step[] = [
  {
    title: "Pick a plan.",
    copy: () =>
      "Pick a plan based on the stage of business that you’re at and your number of team members. ",
    subtitle: "Step 1: ~5mins.",
  },
  {
    title: "Build your brief.",
    copy: () =>
      "This pre-call questionnaire is sent to your mentor before each call to help them prepare.",
    subtitle: "Step 2: ~20mins.",
  },
  {
    title: "Book your call.",
    copy: (firstname) =>
      `Pick from ${String(firstname)} or 100+ other mentors to book your first mentoring session.`,
    subtitle: "Step 3: ~5mins.",
  },
];

const ExpectationsComponent = ({ slug, firstname }: { slug: string, firstname: string }) => {
  const goTo = () =>
    window.open(`https://app.mentorpass.co/signup?mentor=${slug}`);

  return (
    <div className={styles.container}>
      <h3>How to get started.</h3>
      <div className={styles.expectations}>
        {steps.map((step, index) => (
          <div className={styles.expectation} key={`expectations-${index}`}>
            <h4>{step.title}</h4>
            <p>{step.copy(firstname)}</p>
            <div>
              <p>{step.subtitle}</p>
            </div>
          </div>
        ))}
        <div className={styles.expectation}>
          <h4>Ready to get started?</h4>
          <p>Sign up and book your first call today. </p>
          <button
            className="blue_button"
            style={{
              width: "212px",
              margin: "26px 18px 0px 18px",
            }}
            onClick={goTo}
          >
            Book your Call
          </button>
        </div>
      </div>
    </div>
  );
};

export default ExpectationsComponent;
